import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useStyles from './styles';


const Switch = ({ id, checked, onChange, disabled, error }) => {
  const classes = useStyles();

  const containerClass = classnames(
    classes.switchContainer,
    checked ? classes.checkedContainer : classes.uncheckedContainer,
    { [classes.disabled]: disabled },
    { [classes.error]: error },
  );
  const indicatorClass = classnames(
    classes.indicator, checked ? classes.checkedIndicator : classes.uncheckedIndicator,
  );
  return (
    <div
      id={id}
      className={containerClass}
      role="button"
      tabIndex={0}
      onClick={() => { if (!disabled) { onChange(); } }}
      onKeyPress={() => { if (!disabled) { onChange(); } }}
    >
      <div className={indicatorClass} />
    </div>
  );
};


Switch.defaultProps = {
  disabled: false,
  checked: false,
  error: false,
};

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default Switch;
